import ISO6391 from "iso-639-1";

const codes = ISO6391.getAllCodes();

// 2. Convert to German language names
const dn = new Intl.DisplayNames(["de"], { type: "language" });

export const languagesInGerman = codes
  .map((code) => dn.of(code))
  .filter((language) => !!language && language.length > 2);